import List from './List';
export { List };



//////////////////
// WEBPACK FOOTER
// ./src/app/core/setting/index.ts
// module id = 1280
// module chunks = 0